import { Component } from 'react'
import {ProjectTeaser} from 'betterplace-react-components'
import {GtmHelper} from 'shared'
import VisibilitySensor from 'react-visibility-sensor/visibility-sensor'
import Cookies from 'universal-cookie'
const cookies = new Cookies()

export class ProjectTeaserWithTracking extends Component {
  handleClick = () => {
    const { project, trackingPath, index, teaserTracking } = this.props

    GtmHelper.pushProjectClicks(project, index + 1, trackingPath)

    if (teaserTracking) {
      let expires = new Date()
      expires.setTime(expires.getTime() + (3600 * 1000 * 3))
      cookies.set(`teaser-tracker-p${project.id}`, teaserTracking, {path: '/', expires})
    }
  }

  handleVisibilityChange = (isVisible) => {
    if (!isVisible || this.tracked) return
    GtmHelper.pushProjectImpressions(this.props.project, this.props.index + 1, this.props.trackingPath)
    this.tracked = true
  }

  render() {
    return <VisibilitySensor scrollCheck onChange={this.handleVisibilityChange}>
      <ProjectTeaser
        project={this.props.project}
        className={this.props.className}
        showDescription={!!this.props.showDescription}
        progressbarColor={this.props.progressbarColor}
        textColor='#000000'
        onClick={ this.handleClick }
        openInTab={this.props.openInTab} />
    </VisibilitySensor>
  }
}
